import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarOpen: true, // Open by default, will be adjusted by Layout component
  direction: 'rtl',
  theme: 'light',
  notifications: [],
  loading: false,
  error: null
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    setDirection: (state, action) => {
      state.direction = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.push(action.payload);
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        notification => notification.id !== action.payload
      );
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

export const {
  toggleSidebar,
  setSidebarOpen,
  setDirection,
  setTheme,
  addNotification,
  removeNotification,
  setLoading,
  setError,
  clearError
} = uiSlice.actions;

export default uiSlice.reducer; 